module.exports = __webpack_public_path__ + "img/13 Aniamtion 3-squashed.f21496c5.jpg";